<template>
    <div>
        <div class="flex justify-end gap-3">
            <vs-button class="float-right" color="primary" icon-pack="feather" icon="icon-settings"
                       v-if="!isChangeLabel"
                       @click="isChangeLabel = true">
                {{ $t('settings.addSetting') }}
            </vs-button>
            <vs-button @click="saveStatusData" icon-pack="feather" icon="icon-check" v-if="isChangeLabel">
                {{ $t('button.save') }}
            </vs-button>
            <vs-button class="" color="danger" type="border" icon-pack="feather" icon="icon-x" @click="cancelSetting"
                       v-if="isChangeLabel">
                {{ $t('settings.close') }}
            </vs-button>
        </div>
        <div>
            <draggable @end="endMove" :list="dataView" :disabled="!isChangeLabel">
                <div v-for="(item, index) in dataView" :key="index" class="vx-card px-6 py-2 mt-4 ">
                    <div class="vx-row mt-2">
                        <div :class="isChangeLabel ? 'vx-col w-1/3' : 'vx-col w-1/2'">
                            <vs-input v-model="item.label" class="w-full set-input" :readonly="!isChangeLabel"/>
                        </div>
                        <div :class="isChangeLabel ? 'vx-col w-1/3' : 'vx-col w-1/2'">
                            <input type="color" v-model="item.color" class="w-full" :disabled="!isChangeLabel"
                                   style="height: 37.6px">
                        </div>
                        <div :class="isChangeLabel ? 'vx-col w-1/3 flex item-center' : 'hidden'">
                            <vx-tooltip :text="$t('button.delete')" class="flex items-center">
                                <feather-icon svg-classes="h-6 w-6" icon="XSquareIcon" class="text-danger"
                                              @click=" removeItem(index)"></feather-icon>
                            </vx-tooltip>
                        </div>
                    </div>
                </div>
            </draggable>
            <div class="mt-8" v-if="isChangeLabel">
                <vs-button icon-pack="feather" icon="icon-plus" @click="addItem">{{ $t('settings.add') }}</vs-button>
            </div>
        </div>
    </div>

</template>

<script>
import draggable from 'vuedraggable';
import vSelect from 'vue-select'

export default {
    components: {
        draggable,
        vSelect
    },

    data() {
        return {
            isChangeLabel: false,
            labelsOptions: [],
            dataView: [],
            settingsDataNew: {
                color: null,
                order: null,
                label: null,
            },
            body: {},
        }
    },
    created() {
        this.getStt();
    },
    methods: {
        endMove() {
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.order = index;
                });
            }
        },
        cancelSetting() {
            this.isChangeLabel = false
            this.getStt();
        },
        addItem() {
            this.dataView.push({color: '#000000', label: '', order: this.dataView.length,})
        },
        removeItem(index) {
            this.dataView.splice(index, 1);
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.order = index;
                });
            }
        },
        getStt() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.get(`/setting/organization-task-label/find-by-organization-id`).then((response) => {
                    this.$vs.loading.close()
                    if (response.data && response.data.length > 0) {
                        this.dataView = response.data
                        this.labelsOptions = response.data.map(el => {
                            return {
                                value: el.label,
                                label: el.label
                            }
                        })
                    }
                    resolve(response)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',

                    });
                })
            })
        },
        saveStatusData() {
            let item = this.dataView.find(el => el.label.trim().length === 0)
            if (item) {
                return this.$vs.notify({
                    text: 'Không được để trống tiêu đề nhãn!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            this.$vs.loading()
            this.$crm.post(`/setting/organization-task-label/save`, this.dataView).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Tạo mới thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.isChangeLabel = false
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        }
    },
};
</script>

<style></style>
